import type { AuthorizationData, PassFormValues, RegistrationData } from './types';

import type { DictionaryData, tFunction } from 'app/lang';

import dictionary from './components/Signing/Signing.dictionary.json';

export const enum ModalSigningTab {
  AUTHORIZATION = 'authorization',
  REGISTRATION = 'registration',
}

const dataGaValues = { ['data-ga-event']: 'toggleLogInSignIn' };

export const getModalSigningTabsOptions = (t: tFunction) => {
  const options = [
    { label: t(dictionary.authLabel), id: ModalSigningTab.AUTHORIZATION, dataGaValues },
  ];

  return options;
};

export const AUTH_DATA_INITIAL_STATE: AuthorizationData = {
  errorMessage: false,
  shake: false,
  showFieldError: false,
  loginDataChecked: false,
  phone: '',
  isEmptyField: true,
};

export const PASS_FORM_VALUES: PassFormValues = {
  newPass: '',
  login: '',
};

export const SHAKE_ANIM_DURATION = 600;
export const CHECK_ICON_TIME_DURATION = 2000;

export const REG_DATA_INITIAL_STATE: RegistrationData = {
  requisite: '',
  attemptsLeft: 0,
  attemptsTotal: 3,
  resendDate: '',
  serverTime: '',
  sessionToken: null,
  phoneToken: null,
  type: '',
  disabled: false,
  checked: false,
  newPassword: '',
  completed: false,
  regStep: 1,
  codeError: null,
};

export const FORWARD_BUTTON_CONTENT: Record<string, DictionaryData> = {
  STEP1: dictionary.nextStep,
  STEP2: dictionary.nextStep,
  STEP3: dictionary.completeSigning,
  AUTH: dictionary.auth,
  LOGIN: dictionary.login,
};

